export const translationKey = 'builder.career_profile.profile'
